import {Link, Typography} from "@material-ui/core";
import PropTypes, {InferProps} from "prop-types";
import {useKeycloak} from "@react-keycloak/web";
import {useEffect} from "react";


export const AppVersionPropsTypes = {
  versionLabel: PropTypes.string,
}
export type AppVersionProps = InferProps<typeof AppVersionPropsTypes>
const CURRENT_VERSION = process.env.NX_RELEASE_VERSION ? process.env.NX_RELEASE_VERSION : `dev2`
const VERSION_KEY = 'PORTAL_VERSION'
export const AppVersion = (props: AppVersionProps) => {
  const {keycloak, initialized} = useKeycloak()
  const version = localStorage.getItem(VERSION_KEY)
  useEffect(() => {
    if (initialized) {
      if (version) {
        if (version !== CURRENT_VERSION) {

          localStorage.clear()
          localStorage.setItem(VERSION_KEY, CURRENT_VERSION)
        //  keycloak.logout()
        }
      } else {
        localStorage.setItem(VERSION_KEY, CURRENT_VERSION)
      }
    }
  }, [keycloak, initialized])


  return (
    <span>
      <Typography component="p">
        {props.versionLabel ? `${props.versionLabel} :` : ''} {props.versionLabel ? (<Link title={CURRENT_VERSION}
                                                            href={'#'}>{CURRENT_VERSION}</Link>) : ''}
      </Typography>
    </span>
  );
}

AppVersion.propTypes = AppVersionPropsTypes
